"use client";

import Context from "@/context/Context";
import HeaderDashboard from "@/components/Header/HeaderDashboard";
import PopupMobileMenu from "@/components/Header/PopUpMobileMenu";
import Home from "@/components/Home/Home";
import Footer from "@/components/Footers/Footer";
import HomeChatSwitcher from "@/components/Common/HomeChatSwitcher";
import AnnouncementBar from "@/components/Header/AnnouncementBar";

const HomeClient = () => (
  <main className="page-wrapper">
    <Context>
      <AnnouncementBar />
      <HeaderDashboard display="d-none" />
      <PopupMobileMenu />
      <Home />
      <Footer />
      <HomeChatSwitcher />
    </Context>
  </main>
);

export default HomeClient;
